import { Box, Typography } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { If } from "lib/@components/switch"
import { ApplicationIcon } from "./application-icon"

export function ApplicationDisplay({ application, isCollapse }) {
    return (
        <Box component="dl" data-cy="application-display" sx={{ mb: 1, mx: 2, my: 0 }}>
            <Box component="dt" sx={visuallyHidden}>
                {isCollapse ? `Current application: ${application?.name}` : "Current application:"}
            </Box>
            <Box
                component="dd"
                sx={{
                    m: 0,
                    minHeight: 72,
                    display: "flex",
                    alignItems: "center",
                    ...(isCollapse && { justifyContent: "center" }),
                    ...(!isCollapse && { pl: 2 }),
                }}
            >
                <ApplicationIcon appId={application?.id} icon={application?.icon} width={40} height={40} />
                <If value={!isCollapse}>
                    <Typography component="span" variant="subtitle1" noWrap sx={{ ml: 1 }}>
                        {application?.name}
                    </Typography>
                </If>
            </Box>
        </Box>
    )
}
